function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Boc component for home page
 * 
 */
import * as React from 'react';
import './HowTo.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class HowTo extends React.Component {
  render() {
    const {
      items
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "HowTo",
      children: items.map((item, index) => {
        return /*#__PURE__*/_jsxs("div", {
          className: 'box box-' + index,
          children: [/*#__PURE__*/_jsxs("div", {
            className: "head",
            children: [/*#__PURE__*/_jsx("div", {
              className: "index",
              children: index + 1
            }), /*#__PURE__*/_jsx("h4", {
              className: "title",
              children: item.title
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "content",
            children: /*#__PURE__*/_jsx("div", {
              className: "copy",
              dangerouslySetInnerHTML: {
                __html: item.content
              }
            })
          })]
        }, index);
      })
    });
  }
}
_defineProperty(HowTo, "defaultProps", {
  content: []
});
export default HowTo;